import { memo } from 'react'
import { useRouter } from 'next/router'

import { AppLanguage } from '~/types/locale'
import { useGetQuestMetadataQuery } from '~/redux/apis/quest-api'

import Collection from './components/Collection'

function QuestPanel({
  primaryBgColor,
  primeryTxtColor,
}: {
  primaryBgColor: string
  primeryTxtColor: string
}): React.ReactElement {
  const rowClassNames = 'flex flex-col items-center justify-center space-y-3 md:flex-row md:space-x-4 md:space-y-0'

  const router = useRouter()
  const language = router.locale as AppLanguage
  const { data } = useGetQuestMetadataQuery({ language })

  return (
    <section className="relative w-full h-full">
      <div className="flex flex-col">
        <div className={rowClassNames}>
          <Collection data={data} primaryBgColor={primaryBgColor} primeryTxtColor={primeryTxtColor} />
        </div>
      </div>
    </section>
  )
}

export default memo(QuestPanel)
